import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import TopBar from './TopBar';
import SideNav from './SideNav';
import ConnectivityBanner from '@shared/components/ConnectivityBanner';
import ToastProvider from '@shared/components/ToastProvider';
import ErrorBoundary from '@shared/components/ErrorBoundary';
import { useConnectivityDetection } from '@shared/hooks/useConnectivityDetection';

export default function AppShell() {
  useConnectivityDetection();

  return (
    <Box
      data-testid="layout-root"
      sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}
    >
      <TopBar />
      <ConnectivityBanner />
      <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        <SideNav />
        <Box component="main" sx={{ flex: 1, overflow: 'hidden', display: 'flex' }}>
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </Box>
      </Box>
      <ToastProvider />
    </Box>
  );
}
